import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const ArrowRight: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M3 14.6633h20.7867l-6.6934-6.69335c-.52-.52-.52-1.36 0-1.88.52-.52 1.36-.52 1.88 0L28.88 15.9967l-9.9067 9.9066c-.2666.2667-.6.3867-.9466.3867-.3467 0-.68-.1333-.9467-.3867-.52-.52-.52-1.36 0-1.88l6.6933-6.6933H3v-2.6667Z"
    />
  </Icon>
);
